"use strict";

var _toConsumableArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _regeneratorRuntime = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/regenerator/index.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCustomerPartNumber = exports.mapAddressTypesToPricingRequest = exports.includeComboKeyInItem = exports.getPricingOfProductsFromERP = exports.getRequestBodyForERPPricing = exports.getPricingOfProductsFromI2P = exports.getRequestBodyForI2PPricing = exports.cancelAllTokens = exports.cancelToken = void 0;

var axios_1 = __importDefault(require("axios"));

var Enums_1 = require("../Enums");

var Models_1 = require("../Models");

var typeHelpers_1 = require("./typeHelpers");

var cancelToken = function cancelToken(cancelTokenQueue) {
  var cTokenSource = axios_1.default.CancelToken.source(),
      cTokenObject = {
    cancelToken: cTokenSource.token
  };
  cancelTokenQueue && cancelTokenQueue.push(cTokenSource);
  return cTokenObject;
};

exports.cancelToken = cancelToken;

var cancelAllTokens = function cancelAllTokens(queue) {
  var _a;

  while (queue.length > 0) {
    (_a = queue.pop()) === null || _a === void 0 ? void 0 : _a.cancel("Cancelled");
  }
};

exports.cancelAllTokens = cancelAllTokens;

var getRequestBodyForI2PPricing = function getRequestBodyForI2PPricing(_ref) {
  var zipCode = _ref.zipCode,
      items = _ref.items,
      _ref$priceIndividuall = _ref.priceIndividually,
      priceIndividually = _ref$priceIndividuall === void 0 ? true : _ref$priceIndividuall,
      customerPickup = _ref.customerPickup,
      address = _ref.address,
      _ref$shippingPlant = _ref.shippingPlant,
      shippingPlant = _ref$shippingPlant === void 0 ? null : _ref$shippingPlant;
  return Object.assign({
    shippingPlant: shippingPlant,
    type: Models_1.PricingRequestType.Default,
    zipCode: zipCode,
    priceIndividually: priceIndividually,
    items: items,
    shippingType: customerPickup ? Enums_1.ShippingType.customerPickup : Enums_1.ShippingType.standard
  }, address && {
    shipToNumber: address.shipToNumber,
    addressLine: address.addressLine,
    city: address.city,
    state: address.state,
    country: address.country
  });
};

exports.getRequestBodyForI2PPricing = getRequestBodyForI2PPricing;

var getPricingOfProductsFromI2P = function getPricingOfProductsFromI2P(axiosInstance, hasPermissionToviewPrice, requestBody) {
  var onFinish = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
  var onFailure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
  var cancelTokenQueue = arguments.length > 5 ? arguments[5] : undefined;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!hasPermissionToviewPrice) {
              _context.next = 4;
              break;
            }

            cancelTokenQueue && cancelTokenQueue.length && (0, exports.cancelAllTokens)(cancelTokenQueue);
            _context.next = 4;
            return axiosInstance.post(Enums_1.ApiUrl.PRICING_SERVICE, requestBody, cancelTokenQueue ? (0, exports.cancelToken)(cancelTokenQueue) : {}).then(function (response) {
              if ((0, typeHelpers_1.isAxiosError)(response)) {
                throw response;
              } // the hasMessage case is for cancelTokens


              if (hasMessage(response)) {
                // don’t do anything for cancelled request case.
                return;
              }

              onFinish(response);
            }).catch(onFailure);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

exports.getPricingOfProductsFromI2P = getPricingOfProductsFromI2P;

var getRequestBodyForERPPricing = function getRequestBodyForERPPricing(_ref2) {
  var zipCode = _ref2.zipCode,
      items = _ref2.items,
      customerPickup = _ref2.customerPickup,
      address = _ref2.address,
      couponCode = _ref2.couponCode,
      _ref2$shippingPlant = _ref2.shippingPlant,
      shippingPlant = _ref2$shippingPlant === void 0 ? null : _ref2$shippingPlant;
  return Object.assign(Object.assign({
    type: Models_1.PricingRequestType.ShoppingCart,
    zipCode: zipCode,
    items: items,
    shippingType: customerPickup ? Enums_1.ShippingType.customerPickup : Enums_1.ShippingType.standard
  }, address && address), {
    couponCode: couponCode,
    shippingPlant: shippingPlant
  });
};

exports.getRequestBodyForERPPricing = getRequestBodyForERPPricing;

var hasMessage = function hasMessage(obj) {
  return "message" in obj;
};

var getPricingOfProductsFromERP = function getPricingOfProductsFromERP(axiosInstance, requestBody) {
  var onFinish = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  var onFailure = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
  var cancelTokenQueue = arguments.length > 4 ? arguments[4] : undefined;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            cancelTokenQueue && cancelTokenQueue.length && (0, exports.cancelAllTokens)(cancelTokenQueue);
            _context2.next = 3;
            return axiosInstance.post(Enums_1.ApiUrl.PRICING_SERVICE, requestBody, cancelTokenQueue ? (0, exports.cancelToken)(cancelTokenQueue) : {}).then(function (response) {
              if ((0, typeHelpers_1.isAxiosError)(response)) {
                throw response;
              } // the hasMessage case is for cancelTokens


              if (hasMessage(response)) {
                // don’t do anything for cancelled request case.
                return;
              }

              onFinish(response);
            }).catch(onFailure);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};

exports.getPricingOfProductsFromERP = getPricingOfProductsFromERP;

var includeComboKeyInItem = function includeComboKeyInItem(items, products) {
  return _toConsumableArray(items.map(function (item) {
    var _a, _b, _c;

    return Object.assign(Object.assign({}, item), {
      comboKey: (_c = (_a = item.comboKey) !== null && _a !== void 0 ? _a : (_b = products.find(function (product) {
        return product.materialMaster === item.materialSku;
      })) === null || _b === void 0 ? void 0 : _b.comboKey) !== null && _c !== void 0 ? _c : ""
    });
  }));
};

exports.includeComboKeyInItem = includeComboKeyInItem;
/**
    *

@param isLoggedIn
@param defaultShipToAddress
@param shippingAndBillingInformation
@param customerNumber - is required for registered users - please always pass in for logged-in user.
@param customerPickup
@returns
*/

var mapAddressTypesToPricingRequest = function mapAddressTypesToPricingRequest(isLoggedIn, defaultShipToAddress, shippingAndBillingInformation, customerNumber, customerPickup) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j;

  var shipTo;
  var isERPCustomer = !!customerNumber;

  if (isLoggedIn) {
    //If the user is logged in and customer pickup, we will use the default ship to address
    if (isERPCustomer || customerPickup) {
      shipTo = {
        shipToNumber: (_a = defaultShipToAddress === null || defaultShipToAddress === void 0 ? void 0 : defaultShipToAddress.shipToNumber) === null || _a === void 0 ? void 0 : _a.toString(),
        state: defaultShipToAddress.state
      };
    } else {
      if ((defaultShipToAddress === null || defaultShipToAddress === void 0 ? void 0 : defaultShipToAddress.zipCode) && !customerPickup) {
        shipTo = {
          addressLine: defaultShipToAddress.address1,
          city: defaultShipToAddress.city,
          state: defaultShipToAddress.state,
          country: defaultShipToAddress.country
        };
      } else {
        shipTo = {
          state: defaultShipToAddress.state
        };
      }
    }
  } else {
    if (((_b = shippingAndBillingInformation === null || shippingAndBillingInformation === void 0 ? void 0 : shippingAndBillingInformation.shippingInformation) === null || _b === void 0 ? void 0 : _b.shippingAddress) && !customerPickup) {
      shipTo = {
        addressLine: (_d = (_c = shippingAndBillingInformation === null || shippingAndBillingInformation === void 0 ? void 0 : shippingAndBillingInformation.shippingInformation) === null || _c === void 0 ? void 0 : _c.shippingAddress) === null || _d === void 0 ? void 0 : _d.streetAddressOne,
        city: (_f = (_e = shippingAndBillingInformation === null || shippingAndBillingInformation === void 0 ? void 0 : shippingAndBillingInformation.shippingInformation) === null || _e === void 0 ? void 0 : _e.shippingAddress) === null || _f === void 0 ? void 0 : _f.city,
        state: (_g = shippingAndBillingInformation === null || shippingAndBillingInformation === void 0 ? void 0 : shippingAndBillingInformation.shippingInformation) === null || _g === void 0 ? void 0 : _g.shippingAddress.stateProvince,
        country: (_j = (_h = shippingAndBillingInformation === null || shippingAndBillingInformation === void 0 ? void 0 : shippingAndBillingInformation.shippingInformation) === null || _h === void 0 ? void 0 : _h.shippingAddress) === null || _j === void 0 ? void 0 : _j.country
      };
    } else {
      shipTo = {
        state: defaultShipToAddress.state
      };
    }
  }

  return shipTo;
};

exports.mapAddressTypesToPricingRequest = mapAddressTypesToPricingRequest;

var getCustomerPartNumber = function getCustomerPartNumber(altPartNumber) {
  var _a;

  var partNumber = altPartNumber || "";
  return (partNumber === null || partNumber === void 0 ? void 0 : partNumber.slice(0, 3)) === "CPN" ? (_a = partNumber === null || partNumber === void 0 ? void 0 : partNumber.replace("CPN:", "")) === null || _a === void 0 ? void 0 : _a.trim() : "";
};

exports.getCustomerPartNumber = getCustomerPartNumber;